import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getDateInFormat, getFinancialYear, previousDay, } from "@domains/utils/reportDates";
import { FundsDropdown, LEDGER_FILTER_SEGMENT, LedgerRender, LedgerTabsType, } from "./Constants";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { EquityDropdown, } from "@frameworks/web/components/generic/equitydropdown/equitydropdown";
import GenericTable from "@frameworks/web/components/generic/GenericTable";
import "../../../stylesheets/components/Reports/Ledger/LedgerReportsMain.scss";
import ReportValue from "@frameworks/web/components/generic/commonTableVal";
import BreadCrumb from "@frameworks/web/components/generic/BreadCrumb";
import LedgerSnapShot from "./LedgerSnapShot";
import LedgerDetails from "./LedgerDetails";
import LedgerCommonPanel from "./LedgerCommonPanel";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import { ILedgerSnapShotExtentionTYPES, } from "@domains/entities/interfaces/Reports/LedgerReport/ILedgerSnapShotExtention";
import di from "@frameworks/web/components/Reports/LedgerReports/di/servicelocator";
import { accountDetails } from "@di";
import { useDispatch, useSelector } from "react-redux";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import ToggleSwitch from "@frameworks/web/components/generic/SwitchButton/Switch";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import Ledger_CP_Header from "./Ledger_CP_Header";
import moment from "moment";
import mainDI from "@frameworks/web/di/index";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import FilterLabels from "@frameworks/web/components/generic/FilterLabels/FilterLabels";
import { NonStreamReportValue } from "@frameworks/web/components/features/Markets/Equity/commonTablemethods";
import FamilyTaggingMain from "../FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
import { SORTFILTERTABS } from "@frameworks/web/components/features/Offerings/SGB/common/SortFilter";
const LedgerMain = () => {
    const device = DeviceContext();
    const dispatch = useDispatch();
    const { reducersData: snapShot, commonData: snapShotCommonData } = useSelector((state) => state.LedgerReport.snapShot);
    const { reducersData: snapShotExtention, commonData: snapShotExtentionCommonData, } = useSelector((state) => state.LedgerReport.snapShotExtention);
    const filters = useSelector((state) => { var _a, _b; return (_b = (_a = state.LedgerReport.detail) === null || _a === void 0 ? void 0 : _a.reducersData) === null || _b === void 0 ? void 0 : _b.filterData; });
    const getAccountCode = () => {
        accountDetails.getAccountCode().then((x) => {
            setAccCode(x);
        });
    };
    const initStartDate = useCallback(() => {
        if (new Date(finYear, 3, 1) > new Date())
            return new Date(finYear - 1, 3, 1);
        return new Date(finYear, 3, 1);
    }, []);
    const [selectedTab, setSelectedTab] = useState(LedgerTabsType.SNAPSHOT);
    const [accCode, setAccCode] = useState("");
    const [openFamilyDrop, setOpenFamilyDrop] = useState(false);
    const [finYear, setFinYear] = React.useState(getFinancialYear(new Date()));
    const [nextFinYear, setNextFinYear] = React.useState(finYear + 1);
    const [startDate, setStartDate] = React.useState(initStartDate());
    const [endDate, setEndDate] = React.useState(previousDay);
    const [MTFToggle, setMTFToggle] = useState(false);
    const [ledgerReport, setLedgerReport] = React.useState(LedgerRender.LEDGEREPORT);
    const [snapExtension, setSnapExtention] = React.useState(ILedgerSnapShotExtentionTYPES.PAYIN);
    const [showCOMEQTOGGLE, setShowCOMEQTOGGLE] = React.useState(false);
    //toggle Value for COMEQ account
    const [COMEQTOGGLE, setCOMEQTOGGLE] = React.useState(ILoginAccountTypes.EQ);
    //set account Type from loginData
    const [accType, setAccType] = useState();
    // CommonPanel States
    const [openCalendarDrawer, setOpenCalendarDrawer] = useState(false);
    const [openCalendar, setOpenCalendar] = useState(false);
    const [downloadPopUp, setDownloadPopUp] = useState(false);
    const [showFilterAssetDropdown, setshowFilterAssetDropdown] = React.useState(false);
    const [segmentFilterList, setSegmentFilterList] = React.useState(LEDGER_FILTER_SEGMENT);
    const [selectedSegmentFilter, setSelectedSegmentFilter] = useState(segmentFilterList[0]);
    const [showFDot, setShowFDot] = React.useState(0);
    const [allowMTF, setAllowMTF] = useState(false);
    const [selectedFilterTray, setSelectedFilterTray] = useState({
        simpleFilter: true,
        assetFilter: false,
    });
    const [sortOrFilterActiveKey, setSortOrFilterActiveKey] = useState(SORTFILTERTABS.SORT);
    const breadCrumbList = [
        {
            title: "Ledger Report",
            onClick: () => {
                setLedgerReport(LedgerRender.LEDGEREPORT);
            },
            link: "/reports?reportName=otherReports&tab=ledger-report",
        },
        {
            title: FundsDropdown.find((x) => x.value == snapExtension).title,
        },
    ];
    const handleFamilyApply = (accCodes) => {
        setAccCode(accCodes);
        setOpenFamilyDrop(false);
    };
    const LedgerTabs = [
        {
            title: "Quick Snapshot",
            eventKey: LedgerTabsType.SNAPSHOT,
            tabContent: (React.createElement(React.Fragment, null, selectedTab === LedgerTabsType.SNAPSHOT && (React.createElement(React.Fragment, null,
                React.createElement(LedgerCommonPanel, { finYear: finYear, nextFinYear: nextFinYear, startDate: startDate, endDate: endDate, MTFToggle: MTFToggle, setNextFinYear: setNextFinYear, setStartDate: setStartDate, setEndDate: setEndDate, setMTFToggle: setMTFToggle, setFinYear: setFinYear, selectedTab: selectedTab, COMEQTOGGLE: COMEQTOGGLE, accType: accType, setOpenCalendarDrawer: setOpenCalendarDrawer, openCalendarDrawer: openCalendarDrawer, setDownloadPopUp: setDownloadPopUp, downloadPopUp: downloadPopUp, showFilterAssetDropdown: showFilterAssetDropdown, setshowFilterAssetDropdown: setshowFilterAssetDropdown, setOpenCalendar: setOpenCalendar, openCalendar: openCalendar, selectedSegmentFilter: selectedSegmentFilter, setSelectedSegmentFilter: setSelectedSegmentFilter, segmentFilterList: segmentFilterList, setSegmentFilterList: setSegmentFilterList, showFDot: showFDot, setShowFDot: setShowFDot, filters: filters, allowMTF: allowMTF, accCode: accCode, setAccCode: setAccCode, setOpenFamilyDrop: setOpenFamilyDrop, openFamilyDrop: openFamilyDrop, handleFamilyApply: handleFamilyApply, acccodes: accCode, selectedFilterTray: selectedFilterTray, setSelectedFilterTray: setSelectedFilterTray, setSortOrFilterActiveKey: setSortOrFilterActiveKey, sortOrFilterActiveKey: sortOrFilterActiveKey }),
                React.createElement(LedgerSnapShot, { MTFToggle: MTFToggle, setLedgerReport: setLedgerReport, snapExtension: snapExtension, setSnapExtention: setSnapExtention, startDate: startDate, endDate: endDate, COMEQTOGGLE: COMEQTOGGLE, accType: accType, accCode: accCode }))))),
        },
        {
            title: "Detailed Report",
            eventKey: LedgerTabsType.DETAILED,
            tabContent: (React.createElement(React.Fragment, null, selectedTab === LedgerTabsType.DETAILED && (React.createElement(React.Fragment, null,
                React.createElement(LedgerCommonPanel, { finYear: finYear, nextFinYear: nextFinYear, startDate: startDate, endDate: endDate, MTFToggle: MTFToggle, setNextFinYear: setNextFinYear, setStartDate: setStartDate, setEndDate: setEndDate, setMTFToggle: setMTFToggle, setFinYear: setFinYear, selectedTab: selectedTab, COMEQTOGGLE: COMEQTOGGLE, accType: accType, setOpenCalendarDrawer: setOpenCalendarDrawer, openCalendarDrawer: openCalendarDrawer, setDownloadPopUp: setDownloadPopUp, downloadPopUp: downloadPopUp, showFilterAssetDropdown: showFilterAssetDropdown, setshowFilterAssetDropdown: setshowFilterAssetDropdown, setOpenCalendar: setOpenCalendar, openCalendar: openCalendar, selectedSegmentFilter: selectedSegmentFilter, setSelectedSegmentFilter: setSelectedSegmentFilter, segmentFilterList: segmentFilterList, setSegmentFilterList: setSegmentFilterList, showFDot: showFDot, setShowFDot: setShowFDot, filters: filters, allowMTF: allowMTF, accCode: accCode, setAccCode: setAccCode, setOpenFamilyDrop: setOpenFamilyDrop, openFamilyDrop: openFamilyDrop, handleFamilyApply: handleFamilyApply, acccodes: accCode, selectedFilterTray: selectedFilterTray, setSelectedFilterTray: setSelectedFilterTray, setSortOrFilterActiveKey: setSortOrFilterActiveKey, sortOrFilterActiveKey: sortOrFilterActiveKey }),
                React.createElement(LedgerDetails, { MTFToggle: MTFToggle, startDate: startDate, endDate: endDate, COMEQTOGGLE: COMEQTOGGLE, accType: accType, setSegmentFilterList: setSegmentFilterList, setSelectedSegmentFilter: setSelectedSegmentFilter, accCode: accCode }))))),
        },
    ];
    const snapShotExtentionTable = useMemo(() => [
        {
            columnName: "Date",
            arrows: true,
            key: "date",
            onlyOneArrowAtaTime: true,
            type: "Date",
            applySorting: true,
            tdCustomFunction: addDashIfNullOrUndefined,
            columnClassName: "RobotoM_14_500",
        },
        {
            columnName: "Narration",
            arrows: true,
            key: "narration",
            onlyOneArrowAtaTime: true,
            type: "string",
            applySorting: true,
            tdCustomFunction: (key) => {
                return key.length < 18 ? (React.createElement("div", { className: "DMSanM_14_500 text-start" }, addDashIfNullOrUndefined(key))) : (React.createElement(GenericTooltip, { placement: "top", toolTipText: addDashIfNullOrUndefined(key), triggerType: "hover", button: React.createElement("div", { className: "textOverflow-max125 DMSanM_14_500 text-start" }, addDashIfNullOrUndefined(key)), externalClassName: "remove-btn-props", toolTipClassName: "blue-common-tooltip tooltip-invert" }));
            },
            columnClassName: "DMSan_14_500 textOverflow-max96",
        },
        {
            columnName: "Exchange",
            arrows: true,
            key: "exchange",
            onlyOneArrowAtaTime: true,
            type: "string",
            applySorting: true,
            tdCustomFunction: addDashIfNullOrUndefined,
            columnClassName: "RobotoM_16_500",
        },
        {
            columnName: "Receipts",
            arrows: true,
            key: "receiptsInRs",
            onlyOneArrowAtaTime: true,
            type: "number",
            applySorting: true,
            tdCustomFunction: (key) => {
                return NonStreamReportValue(key);
            },
            columnClassName: "RobotoM_16_500",
        },
        {
            columnName: "Payments",
            arrows: true,
            key: "paymentsInRs",
            onlyOneArrowAtaTime: true,
            type: "number",
            applySorting: true,
            tdCustomFunction: (key) => {
                return NonStreamReportValue(key);
            },
            columnClassName: "RobotoM_16_500",
        },
    ], []);
    const handleBeforeUnload = () => {
        sessionStorage.removeItem("simpleFilter");
        sessionStorage.removeItem("assetFilter");
    };
    useEffect(() => {
        accountDetails.getAccTyp().then((val) => {
            setAccType(val);
            if (val === ILoginAccountTypes.COMEQ)
                setShowCOMEQTOGGLE(true);
            else
                setShowCOMEQTOGGLE(false);
        });
        //clear session filters
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, []);
    useEffect(() => {
        if (device === null || device === void 0 ? void 0 : device.isDesktop)
            mainDI.header.RemoveHeaderData(true);
        else
            mainDI.header.RemoveHeaderData(false);
        dispatch(mainDI.footer.updateShowMob_Menu(false));
    }, [device]);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [ledgerReport]);
    React.useEffect(() => {
        //Commodity does not have MTF
        if (accType === ILoginAccountTypes.COMEQ) {
            if (COMEQTOGGLE === ILoginAccountTypes.CO)
                setAllowMTF(false);
            else if (COMEQTOGGLE === ILoginAccountTypes.EQ) {
                setAllowMTF(true);
                setMTFToggle(false);
            }
        }
    }, [COMEQTOGGLE, accType]);
    React.useEffect(() => {
        //Commodity does not have MTF
        if (accType && accType !== ILoginAccountTypes.CO)
            accountDetails.getProducts().then((prds) => {
                prds.forEach((product) => {
                    product.prd.forEach((val) => {
                        if (val.prdVal === "MTF")
                            setAllowMTF(true);
                    });
                });
            });
    }, [accType]);
    useEffect(() => {
        getAccountCode();
    }, []);
    const renderLedgerReports = () => {
        var _a, _b, _c;
        switch (ledgerReport) {
            case LedgerRender.LEDGEREPORT:
                return (React.createElement("div", { className: "ledgers-report-container addFamily-modal-mob" },
                    React.createElement("div", { className: (device === null || device === void 0 ? void 0 : device.isDesktop)
                            ? "d-flex align-items-center justify-content-between  mb-19 mgt-30 "
                            : "pdt-30 px-15" },
                        React.createElement("div", { className: `txt-midnight-blue ${(device === null || device === void 0 ? void 0 : device.isDesktop) ? "DMSan_28_700" : "DMSansBold_20_700"}` }, "Ledger"),
                        React.createElement("div", { className: "d-flex align-items-center justify-content-between gap-10 " },
                            showCOMEQTOGGLE && (React.createElement("div", { className: `d-flex gap-1 toggle-ledger-change txt_blackOne1 DMSans_16_500 ${(device === null || device === void 0 ? void 0 : device.isDesktop) ? "" : "mt-3"}` },
                                React.createElement("span", { className: `${COMEQTOGGLE === ILoginAccountTypes.EQ &&
                                        "txt-midnight-blue DMSan_16_700"}` }, "Equity"),
                                React.createElement("span", null,
                                    React.createElement(ToggleSwitch, { id: "ComEq", name: "ComEq", checked: COMEQTOGGLE === ILoginAccountTypes.EQ ? false : true, onChange: (checked) => {
                                            if (checked) {
                                                setCOMEQTOGGLE(ILoginAccountTypes.CO);
                                                setMTFToggle(false);
                                            }
                                            else
                                                setCOMEQTOGGLE(ILoginAccountTypes.EQ);
                                        }, small: true })),
                                React.createElement("span", { className: COMEQTOGGLE === ILoginAccountTypes.CO &&
                                        "txt-midnight-blue DMSan_16_700" }, "Commodity"))),
                            (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(FamilyTaggingMain, { hideConsolidated: false, handleApply: (accountCode) => {
                                    handleFamilyApply(accountCode);
                                }, setOpenFamilyDrop: setOpenFamilyDrop, openFamilyDrop: openFamilyDrop }))),
                        !(device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(Ledger_CP_Header, { startDate: startDate, setStartDate: setStartDate, endDate: endDate, setEndDate: setEndDate, MTFToggle: MTFToggle, setMTFToggle: setMTFToggle, nextFinYear: nextFinYear, setNextFinYear: setNextFinYear, finYear: finYear, setFinYear: setFinYear, selectedTab: selectedTab, openCalendarDrawer: openCalendarDrawer, setOpenCalendarDrawer: setOpenCalendarDrawer, setshowFilterAssetDropdown: setshowFilterAssetDropdown, setDownloadPopUp: setDownloadPopUp, accType: accType, COMEQTOGGLE: COMEQTOGGLE, setOpenCalendar: setOpenCalendar, openCalendar: openCalendar, filterData: filters, showFilterAssetDropdown: showFilterAssetDropdown, selectedSegmentFilter: selectedSegmentFilter, setSelectedSegmentFilter: setSelectedSegmentFilter, segmentFilterList: segmentFilterList, setSegmentFilterList: setSegmentFilterList, showFDot: showFDot, allowMTF: allowMTF, accCode: accCode, setAccCode: setAccCode, setOpenFamilyDrop: setOpenFamilyDrop, openFamilyDrop: openFamilyDrop, handleFamilyApply: handleFamilyApply }))),
                    (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement("div", { className: "asondate RobotoR_14_400 txt_blackOne1" },
                        "As on ",
                        moment(previousDay).format("DD-MM-YY"))),
                    React.createElement("div", null,
                        !(device === null || device === void 0 ? void 0 : device.isDesktop) && selectedTab == LedgerTabsType.DETAILED && (React.createElement("div", { className: "filter-tags" }, filters &&
                            Object.entries(filters).map((val) => {
                                if (val[1] && val[1].filters)
                                    return val[1].filters.map((tags, idxb) => {
                                        if (val[1].name ===
                                            di.ledger.filterState.productAssetFilter.name)
                                            return;
                                        return (tags.selected && (React.createElement("div", { key: idxb },
                                            React.createElement(FilterLabels, { LabelText: tags.title, closeBtn: true, FilterAction: (filtername) => di.ledger.removeOneFilter(filtername) }))));
                                    });
                            }))),
                        React.createElement(GenericTabs, { defaultActiveKey: selectedTab, tabsArray: LedgerTabs, externalClassName: "subscriptionfeeborder tabs-flex-direction common-tab-color  common-reports-download-mail", callBackFunction: setSelectedTab }))));
            case LedgerRender.FUNDSDETAILS:
                let receiptsInRs = 0, paymentsInRs = 0;
                (_a = snapShotExtention.snapShotExtention) === null || _a === void 0 ? void 0 : _a.forEach((val, idx) => {
                    if (!!val.receiptsInRs)
                        receiptsInRs += Number(val.receiptsInRs.replace(/,/g, ""));
                    if (!!val.paymentsInRs)
                        paymentsInRs += Number(val.paymentsInRs.replace(/,/g, ""));
                });
                return (device.isDesktop && (React.createElement("div", { className: "ledgers-report-container addFamily-modal-mob mt-5" },
                    React.createElement(BreadCrumb, { list: breadCrumbList, parentClassName: "mt-4" }),
                    React.createElement(EquityDropdown, { itemlist: FundsDropdown.filter((x) => {
                            var _a;
                            return ((_a = snapShot.snapShot.find((y) => x.title.toLowerCase() == y.asset.toLowerCase())) === null || _a === void 0 ? void 0 : _a.assetVal) !== 0;
                        }), defaultVal: true, selectedDefaultVal: FundsDropdown.find((x) => x.value === snapExtension), selectedValue: (item) => {
                            let payload = {
                                fromDate: getDateInFormat(startDate, "YYYY-MM-DD"),
                                toDate: getDateInFormat(endDate, "YYYY-MM-DD"),
                                segment: null,
                                currentValue: "1",
                                flag: item.value,
                                accountId: accCode,
                            };
                            di.ledger.snapShotExtentionDetails(payload);
                            setSnapExtention(item.value);
                        }, externalClassname: "ledger-dropdown-new DMSan_14_700 ledger-dropdown-new-btn fundsDropdown", bigIcon: true, ddmenuClassName: "h-auto", highlightSelectedItem: true }),
                    React.createElement(GenericTable, { columns: snapShotExtentionTable, data: ((_b = snapShotExtention.snapShotExtention) === null || _b === void 0 ? void 0 : _b.length) > 0
                            ? snapShotExtention.snapShotExtention
                            : [], parentClassName: "common-table-border table mt-2", loader: snapShotExtentionCommonData.loader, message: snapShotExtentionCommonData.message, shimmer: React.createElement(Common_Shimmer, null), rowClassName: "snapShotExtentionTableRow", 
                        // tableClassName="table-layout-fixed"
                        paths: Array(3)
                            .fill("")
                            .map((_, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` }))) }),
                    ((_c = snapShotExtention.snapShotExtention) === null || _c === void 0 ? void 0 : _c.length) > 0 && (React.createElement(GridContainer, { parentClass: "mb-3 ledger-total " },
                        React.createElement("div", { className: "ledger-total-row" },
                            React.createElement("div", { className: "DMSan_14_700" }, "Total"),
                            React.createElement("div", null),
                            React.createElement("div", null),
                            React.createElement("div", { className: "Roboto_16_400  pd-36" },
                                React.createElement(ReportValue, { val: receiptsInRs, stream: true, onlyval: true, issuffixhide: true })),
                            React.createElement("div", { className: "Roboto_16_400 pd-36" },
                                React.createElement(ReportValue, { val: paymentsInRs, stream: true, onlyval: true, issuffixhide: true }))))))));
        }
    };
    return (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(GridContainer, { parentClass: "px-0" }, renderLedgerReports())) : (React.createElement("div", { className: "" },
        " ",
        renderLedgerReports()));
};
export default LedgerMain;
